module.exports = __webpack_public_path__ + "img/confluence.9d2d1e83.svg";